export enum E_NEWSLETTER_DETAIL_SOURCE {
    MY = 'my',
    LIST = 'list'
}
